import { module } from 'angular';

import { DomainDashboard, DomainList, IndicatorList } from './';
import { default as syntheticViewName, SyntheticView } from './synthetic-view.component.ajs';

export default module('hypervision.synthetic-view', [DomainDashboard, DomainList, IndicatorList]).component(
  syntheticViewName,
  new SyntheticView()
).name;
